<template>
  <qx-card-form title="基础信息">
    <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" labelWidth="120px">
      <!-- 选择客户 -->
      <section slot="customer" slot-scope="prop">
        <ChooseCustomer :isRadio="true" v-model="prop.form.customer" @change="onChangeCustomer" />
      </section>
      <!-- 选择客户 -->
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
import {
  getDepartmentAllList,
  getEnumList,
} from 'api';
import {
  customerArchivesAllList,
  customerArchivesDetail,
} from 'api/archives';
import {
  getPreOrNextToday,
} from '@qx/utils/index';
import ChooseCustomer from 'components/choose/customer';
import {mapState} from 'vuex';
export default {
  components: {
    ChooseCustomer,
  },
  data () {
    return {
      baseForm: {
        customerIdOptions: [],
        saleDaparmentOptions: [],
        stateOptions: [],
        inline: true,
        form: [
          {
            label: '客户全称',
            value: 'customer',
            default: {},
            slot: true,
          },
          {
            label: '联系人',
            value: 'lineName',
            type: 'input',
            width: '240px',
          },
          {
            label: '联系手机',
            value: 'lineTel',
            type: 'input',
            width: '240px',
          },
          {
            label: '归属部门',
            value: 'saleDaparment',
            type: 'select',
            width: '240px',
          },
          {
            label: '线路状态',
            value: 'state',
            type: 'select',
            width: '240px',
            default: '1',
            hide: !this.$route.query.id,
          },
          {
            label: '生效日期',
            value: 'effectBegin',
            type: 'date',
            width: '240px',
            attr: {
              time: '00:00:00',
            },
          },
          {
            label: '有效期至',
            value: 'effectEnd',
            type: 'date',
            width: '240px',
            attr: {
              time: '00:00:00',
            },
          },
          {
            label: '客户线路编码',
            value: 'customerLineNo',
            type: 'input',
            width: '240px',
          },
          {
            label: '客户类型',
            value: 'customerType',
            type: 'select',
            hide: true,
          },
        ],
        rules: {
          customer: [ // 客户全称
            { required: true, message: '请输入客户全称', trigger: 'blur' },
          ],
          lineName: [ // 联系人
            { required: true, message: '请输入联系人', trigger: 'blur' },
          ],
          lineTel: [ // 联系手机
            { required: true, message: '请输入联系手机', trigger: 'blur' },
            { validator: this.checkMobile, trigger: 'blur' },
          ],
          saleDaparment: [ // 归属部门
            { required: true, message: '请选择归属部门', trigger: 'blur' },
          ],
          state: [ // 线路状态
            { required: true, message: '请选择线路状态', trigger: 'blur' },
          ],
          effectBegin: [ // 生效日期
            { required: true, message: '请选择生效日期', trigger: 'blur' },
          ],
          effectEnd: [ // 有效期至
            { required: true, message: '请选择有效期至', trigger: 'blur' },
          ],
          // customerLineNo: [ // 客户线路编码
          //   { required: true, message: '请输入客户线路编码', trigger: 'blur' },
          // ],
          customerType: [ // 客户类型
            { required: true, message: '请选择客户类型', trigger: 'blur' },
          ],
        },
      },
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息
    }),
  },
  methods: {
    async getList () {
      this.baseForm.customerIdOptions = await customerArchivesAllList();
      this.baseForm.saleDaparmentOptions = await getDepartmentAllList({
        pid: this.userInfo.staffTFInfo.orgIds,
        isArchive: true,
      });
      const enumsList = await getEnumList({
        codeType: 'CUCUSTOMER_LINE_STATE',
      });
      this.baseForm.stateOptions = enumsList[0];
      const customerTypeList = await getEnumList({
        codeType: 'CUSTOMER_TYPE_NAME',
      });
      this.baseForm.customerTypeOptions = customerTypeList[0];
    },

    onChangeCustomer (item) {
      this.$refs.baseForm.setVal('lineName', item.lineName);
      this.$refs.baseForm.setVal('lineTel', item.linePhone);
      this.$refs.baseForm.setVal('saleDaparment', item.orgId);
      this.$refs.baseForm.setVal('saleDaparment', item.orgId);
      this.$refs.baseForm.setVal('customerType', item.customerType);

      this.$emit('onChangeCustomer', item);
    },

    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        formData.customerId = formData.customer.customerId;
        formData.customerName = formData.customer.customerName;
        formData.effectBegin = formData.effectBegin ? this.formatDate(formData.effectBegin) : null; // 生效日期
        formData.effectEnd = formData.effectEnd ? this.formatDate(formData.effectEnd) : null; // 有效期至
        delete formData.customer;
      }
      return formData;
    },

    async cacheData () {
      const res = await this.handleSubData(true);
      return res;
    },
    async sub () {
      const res = await this.handleSubData();
      return res;
    },
    async init (initData) {
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: this.userInfo.customerType === '8',
        names: ['customerType'],
      });

      let data = {};
      if (initData) {
        data = initData;
      } else if (!initData && this.$route.query.customerId) {
        data = await customerArchivesDetail({
          customerId: this.$route.query.customerId,
        });
        data.lineTel = data.linePhone; // 联系手机
        data.saleDaparment = data.orgId; // 归属部门
        // 延迟半秒然后向最后一个结算组件发送数据填入，避免结算组件的数据被初始化数据覆盖
        setTimeout(() => {
          this.$emit('onChangeCustomer', data);
        }, 500);
      }
      if (data.saleDaparment) {
        data.saleDaparment = Number(data.saleDaparment);
      }
      const res = {
        customer: { // 客户全称
          customerId: data.customerId,
          customerName: data.customerName,
        },
        lineName: data.lineName, // 联系人
        lineTel: data.lineTel, // 联系手机
        saleDaparment: data.saleDaparment, // 归属部门
        state: String(data.state === undefined ? 1 : data.state), // 线路状态
        effectBegin: data.effectBegin ? new Date(data.effectBegin) : getPreOrNextToday(), // 生效日期
        effectEnd: data.effectEnd ? new Date(data.effectEnd) : getPreOrNextToday(+1), // 有效期至
        customerLineNo: data.customerLineNo, // 客户线路编码
        customerType: data.customerType,
      };
      this.$refs.baseForm.setVal('form', res);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
